import { createReducer } from "sc/helpers/reducer";
import { USERS_LOADED } from "../actions/users";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [USERS_LOADED]: (state, action) => action.payload.users,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/list-users-reducer.js